import styled from 'styled-components';
import CategoryItem, { getCategoryIcon } from './CategoryItem';
import DownloadIcon from '../../icons/DownloadIcon.svg?react';
import Plane3dIcon from '../../icons/Plane3dIcon.svg?react';

interface CategorySidebarProps {
  categories: string[];
  selectedCategory: string | null;
  onCategorySelect: (category: string) => void;
  onBackClick: () => void;
}

/**
 * Category sidebar component - displays list of product layers (categories)
 * Shows all available product_layer types from the loaded UGLA file
 */
const CategorySidebar: React.FC<CategorySidebarProps> = ({
  categories,
  selectedCategory,
  onCategorySelect,
  onBackClick,
}) => {
  // Filter out empty categories (shouldn't happen, but safety check)
  const validCategories = categories.filter((cat) => cat && cat.trim().length > 0);

  const CameraIcon = getCategoryIcon("camera")

  if (validCategories.length === 0) {
    return (
      <Container>
        <Title>Categories</Title>
        <EmptyMessage>No categories available</EmptyMessage>
      </Container>
    );
  }

  return (
    <Container>
      <BackButton onClick={onBackClick}>
        <BackButtonIcon>
          <img src='/img/back.svg' alt='back pict'/>
        </BackButtonIcon>
        <BackButtonText>
          GALERIE INSPIRATION
        </BackButtonText>
      </BackButton>
      <Title>Choisissez vos options</Title>
      {/* <Subtitle>Select a category to configure</Subtitle> */}
      <CategoryList>
        {validCategories.map((category) => (
          <CategoryItem
            key={category}
            category={category}
            selected={selectedCategory === category}
            onClick={() => onCategorySelect(category)}
          />
        ))}
      </CategoryList>
      <ActionsContainer>
        <ActionButton>
          <ActionButtonIcon>
            <Plane3dIcon/>
          </ActionButtonIcon>
          <ActionButtonText>
            ACCÉDER AU PLAN 3D 
          </ActionButtonText>
        </ActionButton>
        <ActionButton>
          <ActionButtonIcon>
            <DownloadIcon/>
          </ActionButtonIcon>
          <ActionButtonText>
            ENREGISTRER MA CONFIGURATION 
          </ActionButtonText>
        </ActionButton>
        <ActionButton>
          <ActionButtonIcon>
            <CameraIcon size={30}/> 
          </ActionButtonIcon>
          <ActionButtonText>
            ENREGISTRER UNE PREVIEW 
          </ActionButtonText>
        </ActionButton>
      </ActionsContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  }
`;

const BackButton = styled.div`
  position: relative;
  top: 0;
  // left: -3vw;
  background: ${props => props.theme.colors.backButtonBackground};
  border-radius: 5px;
  padding: .5vh 1vw;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: opacity .2s ease-out;
  &:hover{
    cursor: pointer;
    opacity: .9;
  }
`

const BackButtonIcon = styled.span`
  margin-right: 1vw;
`

const BackButtonText = styled.span`
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 0.9rem;
  color: #fff;
`

const Title = styled.h2`
  color: #ffffff;
  font-family: Poppins-ExtraBold, sans-serif;
  font-size: 1.2rem;
  text-transform: uppercase;
  // font-weight: 700;
  // margin-bottom: 0.5rem;
  letter-spacing: 0.05em;
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
  font-weight: 400;
`;

const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
`;

const EmptyMessage = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  text-align: center;
  padding: 2rem 1rem;
  font-style: italic;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid white;
  padding-top: 2vh;
  width: 100%;
`;

const ActionButton = styled.button`
  border-radius: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 1vh;
  padding: 0 .5rem;
  &:hover{
    cursor: pointer;
  }
`

const ActionButtonIcon = styled.div`
  padding: 4px .8rem 4px .5rem;
  color: black;
  & svg {
    width: 30px;
    height: 30px;
  }
  & svg path {
    fill: black;
  }
`

const ActionButtonText = styled.div`
  font-family: Poppins-Bold, sans-serif;
  font-size: clamp(0.5rem, 0.75vw, 1rem);
  flex-grow: 1;
`

export default CategorySidebar;
